const _isLocal =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

const API_BASE_URL = _isLocal
  ? "http://localhost:3005"
  : "https://api.rendernow.co";

export { API_BASE_URL };
